import STORAGE, { getStorage } from "src/lib/storage"
import ROUTER from "src/router"
import SvgIcon from "../SvgIcon"


export const MenuItem = () => {
  const isLogin = getStorage(STORAGE.TOKEN)
  return [
    {
      label: "Giới thiệu",
      key: ROUTER.HOME,
      publishRouter: true,
      TabID: [999],
    },
    {
      label: "Tin tức",
      key: ROUTER.TIN_TUC,
      publishRouter: true,
      TabID: [999],
    },
    {
      label: "Cẩm nang",
      key: ROUTER.CAM_NANG,
      publishRouter: true,
      TabID: [999],
    },
    {
      label: "Tài liệu",
      key: ROUTER.TAI_LIEU,
      publishRouter: true,
      TabID: [999],
    },
    {
      label: "Đóng góp",
      key: ROUTER.DONG_GOP,
      publishRouter: true,
      TabID: [999],
    },
    {
      label: "Diễn tập",
      key: ROUTER.DIEN_TAP,
      publishRouter: true,
      TabID: [999],
    },
  ]
}
export const MenuItemAdmin = () => {
  // console.log("dossierTotal", dossierTotal)
  return [
    {
      label: "Quản lý diễn tập",
      key: ROUTER.QUAN_LY_DIEN_TAP,
      hideOnMenu: true,
      // showOnAdmin: true,
      publishRouter: true,
      icon: <SvgIcon name="dashboard" />,
      TabID: [1],
    },
    {
      label: "Tiêu chí đánh giá",
      key: ROUTER.TIEU_CHI_DANH_GIA,
      publishRouter: true,
      icon: <SvgIcon name="notes" />,
      TabID: [999],
    },
    {
      label: "Đóng góp",
      key: ROUTER.DONG_GOP_Y_KIEN,
      publishRouter: true,
      icon: <SvgIcon name="icon-system" />,
      TabID: [999],
    },
    {
      label: "Quản lý tài liệu",
      key: ROUTER.QUAN_LY_TAI_LIEU,
      publishRouter: true,
      icon: <SvgIcon name="menu-product" />,
      TabID: [999],
    },
    // {
    //   label: "Quản lý form mẫu",
    //   key: ROUTER.QUAN_LY_FORM_MAU,
    //   publishRouter: true,
    //   icon: <SvgIcon name="menu-product" />,
    //   TabID: [999],
    // },
    {
      label: "Quản trị hệ thống",
      key: "subkey1",
      publishRouter: true,
      icon: <SvgIcon name="people" />,
      TabID: [999],
      children: [
        {
          label: "Danh bạ người dùng",
          key: ROUTER.DANH_BA_NGUOI_DUNG,
          publishRouter: true,
        },
        {
          label: "Phân quyền",
          key: ROUTER.PHAN_QUYEN,
          publishRouter: true,
        },
        {
          label: "Lịch sử hoạt động",
          key: ROUTER.LICH_SU_HOAT_DONG,
          publishRouter: true,
        },
      ],
    },
    {
      label: "Thống kê",
      key: "subkey5",
      publishRouter: true,
      icon: <SvgIcon name="chart" />,
      TabID: [999],
      children: [
        {
          label: "Dashboard",
          key: ROUTER.DASHBOARD,
          publishRouter: true,
        },
        {
          label: "Chi tiết",
          key: ROUTER.CHI_TIET,
          publishRouter: true,
        },
      ],
    },

  ]
}